<template>
  <div class="footer" v-if="showFooter">
    <div class="footer-container">
      <div class="left">
        <div class="logo-box">
          <img src="~@/assets/images/logo.png" class="footer-logo" />
          <p>天科智友</p>
        </div>
        <div class="item-box">
          <p class="font-grey">业务拓展</p>
          <p @click="onMenu('/business')">业务介绍</p>
          <p @click="onMenu('/product')">产品介绍</p>
        </div>
        <div class="item-box third-box">
          <p class="font-grey">企业合作</p>
          <p @click="onMenu('/contactus')">联系我们</p>
          <p @click="openZkyc">中科医创</p>
        </div>
      </div>
      <div class="right">
        <p class="font-grey">咨询电话</p>
        <p class="phone">400-650-1132</p>
        <p>助力业务增长，期待您的合作！</p>
      </div>
    </div>
    <div class="bottom">
      版权所有 ©2023天津天科智友科技有限公司 津ICP备2023002978号-2
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { ref, watch } from "vue";
export default {
  name: "Footer",
  props: {
    msg: String,
  },
  setup() {
    const router = useRouter();
    const onMenu = (path) => {
      router.push(path);
    };
    const openZkyc = () => {
      window.open("https://www.zkyctec.com/");
    };
    var showFooter = ref(true);
    watch(
      () => router.currentRoute.value,
      (newValue) => {
        console.log("footer:", newValue);
        if (newValue.path == "/contactus") {
          showFooter.value = false;
        } else {
          showFooter.value = true;
        }
      },
      { immediate: true }
    );
    return {
      onMenu,
      openZkyc,
      showFooter,
    };
  },
};
</script>
<style scoped lang="scss">
.footer {
  width: 100%;
  box-sizing: border-box;
  padding: 0.469rem /* 90/192 */ 0.911rem /* 175/192 */;
  padding: 70px 100px 30px;
  background: #f7f7f7;
  color: #000;
  font-family: pingfangM;
  margin-top: 10px;
  p {
    margin: 0;
    font-size: 16px /* 24/192 */;
  }
  .font-grey {
    color: #abaaaa;
  }
  .footer-container {
    display: flex;
    // margin-bottom: 0.458rem /* 88/192 */;
    margin-bottom: 40px;
    .left {
      width: 60%;
      display: flex;
      .logo-box {
        width: 35%;
        font-family: pingfangB;
        // text-align: left;
        p {
          font-size: 20px;
        }
        img {
          width: 100px /* 150/192 */;
          height: 85px /* 150/192 */;
        }
      }
      .item-box {
        // text-align: left;
        width: 35%;
        p {
          // margin-bottom: 0.13rem /* 25/192 */ /* 30/192 */;
          margin-bottom: 16px;
          cursor: pointer;
        }
        p:first-child {
          margin-bottom: 20px;
          // margin-bottom: 0.156rem; /* 30/192 */
        }
      }
      .third-box {
        width: 30%;
      }
    }
    .right {
      width: 40%;
      text-align: left;
      justify-content: flex-start;
      padding-left: 0.781rem /* 150/192 */;
      box-sizing: border-box;
      .phone {
        font-size: 26px /* 26/192 */;
        color: #0eadb1;
        font-weight: 700;
        margin-top: 20px /* 45/192 */;
        margin-bottom: 10px;
      }
    }
  }
  .bottom {
    font-size: 14px /* 18/192 */;
  }
}
</style>
